// Extension du SliderComponent pour gérer le slider horizontal desktop sur la galerie produit
document.addEventListener('DOMContentLoaded', function () {
	// N'exécuter ce script QUE sur desktop pour ne pas casser le comportement mobile natif
	if (window.innerWidth < 1200) return;
	
	const productGallerySlider = document.querySelector('.product__media-gallery .slider-mobile-gutter');
	if (!productGallerySlider) return;

	// Surcharger initPages pour forcer le scroll horizontal
	const originalInitPages = productGallerySlider.initPages;
	if (originalInitPages) {
		productGallerySlider.initPages = function () {
			this.sliderItemsToShow = Array.from(this.sliderItems).filter(
				(element) => element.clientHeight > 0,
			);
			
			if (this.sliderItemsToShow.length < 2) return;

			this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
			this.slidesPerPage = Math.floor(
				(this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset,
			);
			this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;

			this.update();
		};
	}

	// Surcharger update pour utiliser scrollLeft et respecter le flag isScrollingByButton
	const originalUpdate = productGallerySlider.update;
	if (originalUpdate) {
		productGallerySlider.update = function () {
			if (!this.slider || !this.nextButton || this.isScrollingByButton) return;

			const previousPage = this.currentPage;
			this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

			if (this.currentPageElement && this.pageTotalElement) {
				this.currentPageElement.textContent = this.currentPage;
				this.pageTotalElement.textContent = this.totalPages;
			}

			if (this.currentPage !== previousPage) {
				const currentElement = this.sliderItemsToShow && this.sliderItemsToShow[this.currentPage - 1];
				
				if (currentElement) {
					this.dispatchEvent(
						new CustomEvent('slideChanged', {
							detail: {
								currentPage: this.currentPage,
								currentElement: currentElement,
							},
						}),
					);
				}
			}

			if (this.enableSliderLooping) return;

			const isSliderAtStart = this.slider.scrollLeft === 0;
			const isFirstSlideVisible = this.isSlideVisible(this.sliderItemsToShow[0]);

			if (isFirstSlideVisible && isSliderAtStart) {
				this.prevButton.setAttribute('disabled', 'disabled');
			} else {
				this.prevButton.removeAttribute('disabled');
			}

			if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
				this.nextButton.setAttribute('disabled', 'disabled');
			} else {
				this.nextButton.removeAttribute('disabled');
			}
		};
	}

	// Surcharger isSlideVisible pour utiliser scroll horizontal
	const originalIsSlideVisible = productGallerySlider.isSlideVisible;
	if (originalIsSlideVisible) {
		productGallerySlider.isSlideVisible = function (element, offset = 0) {
			const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
			return (
				element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
				element.offsetLeft >= this.slider.scrollLeft
			);
		};
	}

	// Surcharger onButtonClick pour scroll horizontal avec synchronisation thumbnail
	const originalOnButtonClick = productGallerySlider.onButtonClick;
	if (originalOnButtonClick) {
		productGallerySlider.onButtonClick = function (event) {
			event.preventDefault();
			const step = event.currentTarget.dataset.step || 1;
			const direction = event.currentTarget.name;

			// Calculer la page actuelle basée sur la POSITION DE SCROLL RÉELLE
			const actualCurrentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;
			
			// Calculer la nouvelle page
			let newPage;
			if (direction === 'next') {
				newPage = Math.min(actualCurrentPage + parseInt(step), this.totalPages);
			} else {
				newPage = Math.max(actualCurrentPage - parseInt(step), 1);
			}
			
			this.currentPage = newPage;
			
			// Flag pour empêcher les événements parasites pendant le scroll
			this.isScrollingByButton = true;

			// Scroller à la position exacte de la nouvelle slide
			this.slideScrollPosition = (newPage - 1) * this.sliderItemOffset;

			this.slider.scrollTo({
				left: this.slideScrollPosition,
			});
			
			// Reset le flag après animation
			setTimeout(() => {
				this.isScrollingByButton = false;
			}, 500);
			
			// Dispatcher slideChanged pour synchroniser les thumbnails
			const currentElement = this.sliderItemsToShow && this.sliderItemsToShow[newPage - 1];
			
			if (currentElement) {
				this.dispatchEvent(
					new CustomEvent('slideChanged', {
						detail: {
							currentPage: newPage,
							currentElement: currentElement,
						},
					}),
				);
			}
			
			// Mettre à jour l'état des boutons après le changement de page
			if (!this.enableSliderLooping) {
				// Bouton Previous
				if (newPage === 1) {
					this.prevButton.setAttribute('disabled', 'disabled');
				} else {
					this.prevButton.removeAttribute('disabled');
				}
				
				// Bouton Next
				if (newPage === this.totalPages) {
					this.nextButton.setAttribute('disabled', 'disabled');
				} else {
					this.nextButton.removeAttribute('disabled');
				}
			}
		};
	}

	// Réinitialiser
	if (productGallerySlider.initPages) {
		productGallerySlider.initPages();
	}
	
	// Re-attacher les event listeners des boutons
	if (productGallerySlider.prevButton && productGallerySlider.nextButton) {
		const oldPrevButton = productGallerySlider.prevButton;
		const oldNextButton = productGallerySlider.nextButton;
		
		const newPrevButton = oldPrevButton.cloneNode(true);
		const newNextButton = oldNextButton.cloneNode(true);
		
		oldPrevButton.parentNode.replaceChild(newPrevButton, oldPrevButton);
		oldNextButton.parentNode.replaceChild(newNextButton, oldNextButton);
		
		productGallerySlider.prevButton = newPrevButton;
		productGallerySlider.nextButton = newNextButton;
		
		newPrevButton.addEventListener('click', productGallerySlider.onButtonClick.bind(productGallerySlider));
		newNextButton.addEventListener('click', productGallerySlider.onButtonClick.bind(productGallerySlider));
	}

	// Cloner le slider pour supprimer les listeners de scroll parasites
	const oldSlider = productGallerySlider.slider;
	if (oldSlider) {
		const newSlider = oldSlider.cloneNode(true);
		oldSlider.parentNode.replaceChild(newSlider, oldSlider);
		
		productGallerySlider.slider = newSlider;
		productGallerySlider.sliderItems = newSlider.querySelectorAll('[id^="Slide-"]');
		productGallerySlider.sliderItemsToShow = Array.from(productGallerySlider.sliderItems).filter(
			(element) => element.clientHeight > 0,
		);
		
		// Ajouter listener de scroll pour swipe/scroll manuel
		let scrollTimeout;
		newSlider.addEventListener('scroll', function() {
			if (productGallerySlider.isScrollingByButton) return;
			
			clearTimeout(scrollTimeout);
			scrollTimeout = setTimeout(function() {
				if (!productGallerySlider.sliderItemOffset || productGallerySlider.sliderItemOffset <= 0) return;
				
				const newPage = Math.round(newSlider.scrollLeft / productGallerySlider.sliderItemOffset) + 1;
				const currentElement = productGallerySlider.sliderItemsToShow && productGallerySlider.sliderItemsToShow[newPage - 1];
				
				if (currentElement && productGallerySlider.currentPage !== newPage) {
					productGallerySlider.currentPage = newPage;
					
					productGallerySlider.dispatchEvent(
						new CustomEvent('slideChanged', {
							detail: {
								currentPage: newPage,
								currentElement: currentElement,
							},
						}),
					);
				}
			}, 100);
		});
	}
});
